import { filtersHelper } from '@/utils';
import { orientationModuleHeaderModel } from '@/models/api/orientationModuleHeader.model';

export const orientationModuleModel = (data) => ({
    uuid: data.uuid,
    name: data.name,
    type: data.type, // 1 - SCORM, 2 - anything else (eg. videos)
    passingPoint: data.passing_point,
    imageUrl: data.image_url,
    imageLaunchUrl: data.image_launch_url,
    scormUrl: data.scorm_url,
    scormLaunchUrl: data.scorm_launch_url,
    sequence: data.sequence,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    group: data.group ? ({
        uuid: data.group.uuid,
        sequence: data.group.sequence,
        isActive: data.group.is_active,
        createdAt: filtersHelper.getDateFormat(data.group.created_at),
        createdBy: data.group.created_by,
        updatedAt: filtersHelper.getDateFormat(data.group.updated_at),
        updatedBy: data.group.updated_by,
        header: data.group.header ? (orientationModuleHeaderModel(data.group.header)) : null,
    }) : null,
});